var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.componentes),function(componente,index){return _c('div',{key:index},[(_vm.current(componente))?_c(componente,{tag:"component",on:{"isValidGlobal":function($event){return _vm.$emit('isValidGlobal', $event)}}}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }